import { environment } from './environment';
import * as Constants from 'src/app/app.constants';

/**
 * Questa sezione è destinata alla configurazione dell'albero di navigazione per la produzione
 */
export const configAppPages = {
  navigation: {
    itinerary: false,

  },
  
 
  APP_PAGES: [
    {
      title: 'Home',
      url: '/home',
      icon: 'home',
      isVisible: true,
      forDesktop: false,    
      child: []
  
    },
    {
      title: 'TYPE.ATTRACTOR.NAME',
      url: '/menu/pois-list/01',
      icon: 'camera',
      isVisible: true,
      forDesktop: true,    
      child: []
    },
    {
      title: 'TYPE.RESTAURANT.NAME',
      url: '/menu/pois-list/02',
      icon: 'restaurant',
      isVisible: true,
      forDesktop: true,    
      child: []
    },
    {
      title: 'TYPE.ACCOMODATION.NAME',
      url: '/menu/pois-list/03',
      icon: 'bed',
      isVisible: true,
      forDesktop: true,    
      child: []
    },
    {
      title: 'TYPE.EVENT.NAME',
      url: '/events',
      icon: 'calendar',
      isVisible: true,
      forDesktop: true,    
      child: []
    },
    {
      title: 'TYPE.ITINERARIES.NAME',
      url: '/itineraries-list',
      icon: 'walk',
      isVisible: true,
      forDesktop: true,    
      child: []
    },
    {
      title: 'FAVOURITES_TITLE',
      url: '/favourites-list',
      icon: 'bookmark',
      isVisible: true,
      forDesktop: true,    
      child: []
    },
    {
      title: 'HOME.INTORNO_A_TE.NAME',
      url: '/maps-search',
      icon: 'map',
      isVisible: true,
      forDesktop: true,    
      child: []
    },
    {
      title: 'SETTINGS.SETTINGS_TITLE',
      url: '/settings',
      icon: 'settings',
      isVisible: true,
      forDesktop: false,    
      child: []
    },
    {
      title: 'SETTINGS.SETTINGS_LOGIN',
      url: '/login',
      icon: 'log-in',
      isVisible: false,
      forDesktop: false,    
      child: []
    },
    /*
    Nascondiamo la sezione PROFILO
    {
      title: 'PROFILE_TITLE',
      url: '/profile',
      icon: 'person',
      isVisible: false,
      forDesktop: false
    },
    */
    {
      title: 'SETTINGS.SETTINGS_LOGOUT',
      url: '/logout',
      icon: 'log-out',
      isVisible: false,
      forDesktop: false,    
      child: []
    }
  ]
  ,


};

